import React from 'react';
import { X } from 'lucide-react';

/**
 * Modal Component
 * Komponen modal dasar untuk menampilkan konten dalam overlay
 */
const Modal = ({ isOpen, onClose, title, children, maxWidth = 'max-w-md' }) => {
    if (!isOpen) return null;
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className={`bg-white rounded-2xl shadow-xl p-6 w-full ${maxWidth}`}>
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold text-gray-800">{title}</h3>
                    <button 
                        onClick={onClose} 
                        className="text-gray-500 hover:text-gray-800 p-1 rounded-full hover:bg-gray-100"
                        aria-label="Tutup modal"
                    >
                        <X size={24} />
                    </button>
                </div>
                <div>{children}</div>
            </div>
        </div>
    );
};

export default Modal;

